import React, { useState, useEffect } from 'react';

const weddingDate = new Date('2026-10-24T12:00:00');

const calculateTimeLeft = () => {
  const now = new Date();
  const difference = weddingDate - now;
  
  if (difference <= 0) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      isExpired: true
    };
  }
  
  return {
    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
    hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((difference / 1000 / 60) % 60),
    seconds: Math.floor((difference / 1000) % 60),
    isExpired: false
  };
};

const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    
    return () => clearInterval(timer);
  }, []);
  
  if (timeLeft.isExpired) {
    return (
      <div className="text-center py-8">
        <p className="text-2xl" style={{color: '#d4c5a0', fontFamily: 'Cinzel', letterSpacing: '0.15em'}}>
          JUST MARRIED!
        </p>
      </div>
    );
  }
  
  return (
    <div className="py-6">
      <p className="text-center text-xs tracking-widest mb-4" style={{color: '#d4c5a0', fontFamily: 'Tenor Sans', letterSpacing: '0.2em'}}>
        WE CAN'T WAIT TO SEE YOU IN
      </p>
      <div className="flex justify-center gap-4 md:gap-8">
        {/* Days */}
        <div className="text-center">
          <div className="relative">
            <div 
              className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-lg"
              style={{
                backgroundColor: 'rgba(212, 197, 160, 0.1)',
                border: '2px solid rgba(212, 197, 160, 0.3)'
              }}
            >
              <span className="text-2xl md:text-3xl font-bold" style={{color: '#d4c5a0', fontFamily: 'Cinzel'}}>
                {timeLeft.days}
              </span>
            </div>
          </div>
          <p className="mt-2 text-xs tracking-widest" style={{color: '#d4c5a0', fontFamily: 'Tenor Sans', letterSpacing: '0.15em'}}>
            DAYS
          </p>
        </div>
        
        {/* Hours */}
        <div className="text-center">
          <div className="relative">
            <div 
              className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-lg"
              style={{
                backgroundColor: 'rgba(212, 197, 160, 0.1)',
                border: '2px solid rgba(212, 197, 160, 0.3)'
              }}
            >
              <span className="text-2xl md:text-3xl font-bold" style={{color: '#d4c5a0', fontFamily: 'Cinzel'}}>
                {timeLeft.hours}
              </span>
            </div>
          </div>
          <p className="mt-2 text-xs tracking-widest" style={{color: '#d4c5a0', fontFamily: 'Tenor Sans', letterSpacing: '0.15em'}}>
            HOURS
          </p>
        </div>
        
        {/* Minutes */}
        <div className="text-center">
          <div className="relative">
            <div 
              className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-lg"
              style={{
                backgroundColor: 'rgba(212, 197, 160, 0.1)',
                border: '2px solid rgba(212, 197, 160, 0.3)'
              }}
            >
              <span className="text-2xl md:text-3xl font-bold" style={{color: '#d4c5a0', fontFamily: 'Cinzel'}}>
                {timeLeft.minutes}
              </span>
            </div>
          </div>
          <p className="mt-2 text-xs tracking-widest" style={{color: '#d4c5a0', fontFamily: 'Tenor Sans', letterSpacing: '0.15em'}}>
            MINUTES
          </p>
        </div>
        
        {/* Seconds */}
        <div className="text-center">
          <div className="relative">
            <div 
              className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-lg"
              style={{
                backgroundColor: 'rgba(212, 197, 160, 0.1)',
                border: '2px solid rgba(212, 197, 160, 0.3)'
              }}
            >
              <span className="text-2xl md:text-3xl font-bold" style={{color: '#d4c5a0', fontFamily: 'Cinzel'}}>
                {timeLeft.seconds}
              </span>
            </div>
          </div>
          <p className="mt-2 text-xs tracking-widest" style={{color: '#d4c5a0', fontFamily: 'Tenor Sans', letterSpacing: '0.15em'}}>
            SECONDS
          </p>
        </div>
      </div>
    </div>
  );
};

export default CountdownTimer;
